import React from 'react';
import { MOBILE_SCREEN } from 'consts';
import { useMatchMedia } from 'hooks/useMatchMedia';

import ProductBlock from '../ProductBlock';
import MobileDescription from './MobileDescription';

import { T8y } from 'ui';

import style from './description.module.scss';

export const Description = ({ description }) => {
  const isMobile = useMatchMedia(`(max-width: ${MOBILE_SCREEN}px)`);

  if (isMobile) {
    return <MobileDescription description={description} />;
  }

  return (
    <ProductBlock title="Full Description">
      <T8y variant="t1v1" fullWidth className={style.productDescription}>
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </T8y>
    </ProductBlock>
  );
};
